import { cn } from "@omni/utils/styles";
import { useState } from "react";

import { DefaultFacetDisplayValue } from "./defaultFacet.container";

type DefaultFacetValueComponentProps = {
    value: DefaultFacetDisplayValue;
    showCount: boolean;
};

const DefaultFacetValueComponent = ({
    value,
    showCount
}: DefaultFacetValueComponentProps) => {
    const [isCheckedOptimistic, setIsCheckedOptimistic] = useState<boolean>(
        value.refined
    );

    const handleOnChange = () => {
        setIsCheckedOptimistic((isChecked) => !isChecked);
        value.onRefine();
    };

    return (
        <li>
            <label
                className={cn(
                    "tw:cursor-pointer tw:flex tw:items-center tw:mb-0 tw:py-1"
                )}
                title={value.label}
            >
                <div className={cn("tw:min-w-0 tw:flex tw:items-center")}>
                    <input
                        type={"checkbox"}
                        className={cn("tw:mr-2 tw:cursor-pointer")}
                        checked={isCheckedOptimistic}
                        onChange={handleOnChange}
                    />
                    <div
                        className={cn(
                            "tw:first-letter:capitalize tw:whitespace-nowrap tw:overflow-hidden tw:text-ellipsis",
                            { "tw:font-bold": isCheckedOptimistic }
                        )}
                    >
                        {value.label}
                    </div>
                </div>

                {showCount && (
                    <small className={"tw:pl-2"}>({value.count})</small>
                )}
            </label>
        </li>
    );
};

export { DefaultFacetValueComponent };
